import { extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';

extend('required', {
    ...required,
    message: 'This field is required'
});

extend('name', {
    validate: value => /^[a-zA-Z \/]+$/.test(value),
    message: 'Name should contain only alphabets and spaces'
});

extend('number_only', {
    validate: value => /^[0-9]+$/.test(value),
    message: 'The value must be a number'
});

extend('nric', {
    validate: value => String(value).length > 11,
    message: 'The value must be a number with a maximum length of 12 characters'
});

extend('nric_check', {
    validate: value => {
			 if (!value || value.length < 6) return false; // guard

			// Extract parts
			const yearPrefixPart = parseInt(value.substring(0, 2), 10);
			const yearPrefix = (yearPrefixPart >= 0 && yearPrefixPart <= 39) ? '20' : '19';
			const year = parseInt(yearPrefix + value.substring(0, 2), 10);
			const month = parseInt(value.substring(2, 4), 10);
			const day = parseInt(value.substring(4, 6), 10);

			// Check valid date (similar to PHP's checkdate)
			const date = new Date(year, month - 1, day);
			const isValid =
				date.getFullYear() === year &&
				date.getMonth() === month - 1 &&
				date.getDate() === day;

			return isValid;
		},
    message: 'Invalid NRIC Number'
});

extend('email', {
    ...email,
    message: 'Please enter a valid email address'
});

extend('mobile_no', {
    validate: value => {
        // Check if the value matches the pattern for a Malaysian phone number
        return /^(\+?6?01)[02-46-9]-*[0-9]{7}$|^(\+?6?01)[1]-*[0-9]{8}$/.test(value);
    },
    message: 'Please enter a valid mobile phone number in Malaysia without any ' + '-'
});

extend('phone_prefix', {
    validate: value => {
        // Check if the value matches the pattern for a Malaysian phone number
        // return /^((03|04|05|06|07|080|081|082|083|084|085|086|087|089|09)\d{7,8})$/.test(value);
        return /^(01[0-46-9]-*\d{7,8}|011-\d{7,8}|01[2-35-9]-*\d{7,8}|01[2-9]\d{7,8}|01[2-35-9]-*\d{7,8}|01[2-9]\d{7,8})$/.test(value);
    },
    message: 'Please enter a valid landline phone number in Malaysia'
});

extend('postcode', {
    validate: value => /^\d{5}(?:[-\s]\d{4})?$/.test(value),
    message: 'Please enter a valid postcode'
});

extend('currency', {
    validate: value => /^\d*\.?\d{0,2}$/.test(value),
    message: 'The value must be a number and restricted to two decimal places'
});

export function preventNonNumericInput(event) {
  const allowed = ["Backspace", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Delete"];
  const regex = /^[\d.,$]$/;

  if (!regex.test(event.key) && !allowed.includes(event.key)) {
    event.preventDefault();
  }
}